import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ConfirmDialogData } from '../../models/confirm-dialog.model';

@Component({
  selector: 'ct-confirm-dialog',
  styleUrls: ['./confirm-dialog.component.scss'],
  templateUrl: './confirm-dialog.component.html',
})
export class ConfirmDialogComponent implements OnInit {
  constructor(
    private matDialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData,
  ) {}

  public ngOnInit() {}

  public cancel() {
    this.matDialogRef.close(false);
  }

  public cancelConfirm() {
    this.matDialogRef.close(true);
  }
}
